import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formata um número de telefone brasileiro para exibição.
 * Aceita string com dígitos puros (10 ou 11) ou já formatada.
 *
 * Exemplos:
 *   '11999999999' → '(11) 99999-9999'
 *   '1133334444'  → '(11) 3333-4444'
 *   null/undefined → '—'
 */
@Pipe({ name: 'phone', standalone: true })
export class PhonePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (value == null || value === '') return '—';
    const digits = value.replace(/\D/g, '');
    if (digits.length === 11) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
    }
    if (digits.length === 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    }
    return value;
  }
}
